import React, { useContext, useEffect, useState } from "react";
import { useTheme } from "../../../contexts/Theme/ThemeContext";
import { ContainerFacebookPixel } from "./styles";
import { Input } from "../../Input";
import { Button } from "../../Button";
import { stringNumber } from "../../../services/Masks";
import { ConfiguracoesContext } from "../../../contexts/Configuracoes/ConfiguracoesContext";
import { EmpresaContext } from "../../../contexts/Empresa/EmpresaContext";

export const FacebookPixel: React.FC = () => {
  const { theme } = useTheme();
  let contentValueFacebook = "tpv3500ekojh85gahlygv8hadjn4vj";

  const { configuracoes, setConfiguracoes } = useContext(ConfiguracoesContext);
  const { empresa } = useContext(EmpresaContext);

  const isSuporte = empresa?.usuario === "atendimento_conecta";

  function getContentValue(metaTag) {
    const regex = /content="([^"]*)"/;
    const match = metaTag.match(regex);
    return match ? match[1] : null;
  }

  function extractFacebookPixelId(scriptString) {
    const match = scriptString.match(/fbq\('init',\s*'(\d+)'\)/);
    return match ? match[1] : null;
  }

  useEffect(() => {
    const init = async () => {
      if (configuracoes.facebook_dominio) {
        const contentValue = getContentValue(configuracoes.facebook_dominio);
        if (contentValue) {
          setConfiguracoes({
            ...configuracoes,
            verificacoes_de_dominio: {
              ...configuracoes.verificacoes_de_dominio,
              facebook: contentValue,
            },
          });
        }
      }
      if (configuracoes.facebook_pixel) {
        const facebookPixelId = extractFacebookPixelId(
          configuracoes.facebook_pixel
        );
        if (facebookPixelId) {
          setConfiguracoes({
            ...configuracoes,
            dados_facebook_pixel: {
              ...configuracoes.dados_facebook_pixel,
              id: facebookPixelId,
            },
          });
        }
      }
    };

    init();
  }, [configuracoes]);

  return (
    <ContainerFacebookPixel theme={theme}>
      <div className="textoMeta fonteTexto">
        Aqui você pode conectar seu catálogo ao Meta, incluindo a verificação de domínio e a configuração do pixel. <br />
        Essas integrações são importantes para anunciar com mais eficiência, acompanhar resultados e usar a Sacolinha do Instagram.<br /><br />
        <strong>A configuração é feita pelo time de especialistas do Conecta Venda de forma 100% gratuita — basta solicitar <a href="https://api.whatsapp.com/send/?phone=555434434563&text=Estou+no+painel+do+Conecta+Venda+e+quero+solicitar%20a%20configura%C3%A7%C3%A3o%20do%20Meta%20na%20minha%20conta" target="_blank">clicando aqui.</a></strong>
      </div>
      {isSuporte && (
      <div className="box">
        <div className="input">
          <Input
            type="text"
            label="Verificação de Domínio"
            value={configuracoes.verificacoes_de_dominio.facebook}
            maxLength={30}
            onChange={(newValue) => {
              setConfiguracoes({
                ...configuracoes,
                verificacoes_de_dominio: {
                  ...configuracoes.verificacoes_de_dominio,
                  facebook: newValue,
                },
              });
            }}
            placeholder="tpv3500ekojh85gahlygv8hadjn4vj"
          />
        </div>
        <div className="texto-input fonteRotulos">
          Insira o content do código conforme destaque no exemplo:
          <br />
          {`<meta name="facebook-domain-verification" content="`}
          <strong>{contentValueFacebook}</strong>
          {`" />`}
        </div>
        <div className="input">
          <Input
            type="text"
            label="ID do Facebook Pixel"
            value={configuracoes.dados_facebook_pixel.id}
            maxLength={16}
            mask={{ mask: stringNumber }}
            onChange={(newValue) => {
              setConfiguracoes({
                ...configuracoes,
                dados_facebook_pixel: {
                  ...configuracoes.dados_facebook_pixel,
                  id: newValue,
                },
              });
            }}
            placeholder="Insira o código do Facebook Pixel"
          />
        </div>
        <div className="input">
          <Input
            type="text"
            label="Access Token"
            value={configuracoes.dados_facebook_pixel.token}
            maxLength={255}
            onChange={(newValue) => {
              setConfiguracoes({
                ...configuracoes,
                dados_facebook_pixel: {
                  ...configuracoes.dados_facebook_pixel,
                  token: newValue,
                },
              });
            }}
            placeholder="Insira o código do Access Token"
          />
        </div>
      </div>
      )}
    </ContainerFacebookPixel>
  );
};
